import React, {memo} from "react";
import {styled, Text, ProgressBar as BaseProgressBar} from "@reside/ui";

type Props = Readonly<{
  /**
   * Percentage of completion in range <0, 100>
   */
  progress: number;
  testId?: string;
  /** Omit top margin when nested in a tight row (e.g. dashboard card meta). */
  flushTop?: boolean;
  /** When `progress === 0`, shown instead of the default "Not Started". */
  zeroProgressLabel?: string;
}>;

const BAR_HEIGHT_PX = 5;

export const ProgressBar = memo(
  ({progress, testId, flushTop, zeroProgressLabel}: Props) => (
    <Wrapper $flushTop={flushTop}>
      <BarSlot>
        <BaseProgressBar
          progress={progress}
          testId={testId}
          height={BAR_HEIGHT_PX}
        />
      </BarSlot>
      <PercentLabel color="gray100" fontSize={1} fontWeight="normal">
        {progress === 0 ? zeroProgressLabel ?? "Not Started" : progress + "%"}
      </PercentLabel>
    </Wrapper>
  ),
);

/** UI ProgressBar defaults to width 65px; stretch to flex row. Inner fill uses `height` prop (inline) — must match, not only clip with CSS. */
const BarSlot = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;

  > * {
    width: 100% !important;
    min-width: 0;
  }
`;

const PercentLabel = styled(Text)`
  flex-shrink: 0;
  line-height: 1;
`;

const Wrapper = styled.div<{$flushTop?: boolean}>`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: ${({$flushTop}) => ($flushTop ? 0 : "5px")};
`;
